import { Component } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { NmDatatableSettings } from '../../../widgets/datatable/datatable.interface';
import { HelperService } from '../../../services/helper.service';

import { FormBuilder, FormGroup,FormControl, FormArray, Validators } from '@angular/forms';
import { DataService } from '../../../services/data.service';
import { FormService } from '../../../services/form.service';
import { NmDetailPageClass } from '../../../shared/nm-detail-page-class';

import { ApiService } from '../../../services/api.service';

declare let $: any;
declare let bootbox: any;

@Component({
	selector: 'members-report-page',
	templateUrl: './report.html',
	styleUrls: ['./report.css']
})
export class MembersReportPage {
	public modelName: string = 'member';
	public batchBtnStatus: boolean = true;
	public reloadTable: boolean = false;
	public reported: boolean = false;
	public reportResult: string = '';
	public sendPwdBtnStatus: boolean = true;
	

	public form: FormGroup = this.formBuilder.group({
		// basic information
		file: ['',Validators.required],
		early_bird: [''],
		year: ['']
	});
	public searchFields = {
		// basic information
		Gender: [''],
		YFSID: [''],
		LegacyYFSID: [''],
		HongKongIdentityCard: [''],
		MemberTypeCode: [''],
		FullName: [''],
		ChineseName: [''],
		SchoolId: [''],
		DateOfBirth: [''],
		EmailAddress: [''],
		Telephone1: [''],
		Telephone2: [''],
		StatusCode: [''],
		MembershipYear: ['',Validators.required],
		early_bird: [''],
		//other fields
		schoolYear: [''],
		formClass: [''],
		major: [''],
		AddressLine1: [''],
		AddressLine2: [''],
		AddressLine3: [''],
		SubdistrictId: [''],
		TotalParticipationYears: [''],
		partyear_match: [''],
		FirstJoinYear: [''],
		Language: [''],
		has_coordination: [''],
		Remarks: [''],
		educationLevelId: [''],
		volunteer_type_id: ['']
	};
	public searchForm: FormGroup = this.formBuilder.group(this.searchFields);
	public constructor(
		private helper: HelperService,
		public formBuilder: FormBuilder,

		public data: DataService,
		public _form: FormService,
		public _searchForm: FormService,

		private api: ApiService,
		private router: Router,
		private location: Location,
		private activatedRoute: ActivatedRoute
	) {}

	public allFields  = this.searchFields;

	public ngOnInit() {
		if(!this.modelName) console.error('Missing modelName.');

		
		for(let col in this.allFields){
			this.searchForm.addControl('col_'+col,new FormControl('col_'+col));
		}

		this._form.setForm(this.form);
		this._searchForm.setForm(this.searchForm);
		this.onBeforeRendered();
		let params = this.activatedRoute.snapshot.queryParams;
		
		let initSearch: boolean = false;
		for(let key in params){
			if(params[key] && this.searchForm.controls[key]){
				this.searchForm.controls[key].setValue(params[key]);
				initSearch = true;
			}
			if(key == 'searchall'){
				initSearch = true;
			}
		}
		if(initSearch){
			this.onRunReport();
		}
		for(let col in this.allFields){
			this.searchForm.controls['col_'+col].setValue(true);
		}
		//set default value for selection fields
		this.searchForm.controls['partyear_match'].setValue('=');
		
	}
	public onBeforeRendered() {
		/*let control = <FormArray>this.form.get('_contact_channels');
		for(let channel of this.data.shared.communicationChannels.getValue()) {
			control.push(this.formBuilder.control(false));
		}*/

	}

	public onValidationFail(): void {
		this._searchForm.showErrors();
	};

	



	
	public onRunReport():void{
		if(!this.searchForm.valid){
			this.onValidationFail();
			return;
		}
		console.log(this.searchForm.value);
		let fullMath = ['SchoolId','StatusCode','educationLevelId'];
		this.datatableSetting.fields.map(v => {
			this.searchForm.value[v.name] ? v.search = this.searchForm.value[v.name] : v.search = '';
			for(let k of fullMath){
				if(v.search && v.name == k){
					v.regex = true;
					v.search = '^'+v.search+'$';
				}
			}
			if(v.name == 'DateOfBirth'){
				v.search = this.data.datepicker.toString(this.searchForm.value['DateOfBirth']);
			}
			return v;
		});
		let queryStr = [];
		queryStr.push('export=1');
		/*if(this.searchForm.value['MembershipYear']){
			queryStr.push('MembershipYear='+this.searchForm.value['MembershipYear']);
		}
		if(this.searchForm.value['early_bird']){
			queryStr.push('early_bird='+this.searchForm.value['early_bird']);
		}
		if(this.searchForm.value['has_coordination']){
			queryStr.push('has_coordination='+this.searchForm.value['has_coordination']);
		}
		if(this.searchForm.value['TotalParticipationYears']){
			queryStr.push('TotalParticipationYears='+this.searchForm.value['TotalParticipationYears']);
		}
		if(this.searchForm.value['partyear_match']){
			queryStr.push('partyear_match='+this.searchForm.value['partyear_match']);
		}*/
		for(let col in this.allFields){
			queryStr.push('col_'+col+'='+this.searchForm.value['col_'+col]);
		}
		for(let field in this.searchFields){
			queryStr.push(field+'='+this.searchForm.value[field]);
		}
		let exporturl = '';
		if(queryStr.length > 0){
			exporturl = 'member/report?'+queryStr.join('&');
		}else{
			exporturl = 'member/report';
		}
		//console.log(this.datatableSetting);
		this.reported = true;
		//this._setSearchUrl();
		this.reportResult = '';
		try {
			let promise;
			promise = this.api.sendApiRequest('get', exporturl).toPromise();
			

			promise
			.then(res => {
				//this.onAfterSubmit(true);
				this.reported = false;
				this.reportResult = res._body;
				console.log(res);
			})
			.catch(err => {
				//this.onAfterSubmit(false);
				this.reported = false;
			});
		}
		catch(e) {
			console.error(e);
				this.reported = false;
		}

	}
	private _setSearchUrl(){
		let querys = [];
		for(let name in this.searchForm.value){
			if(this.searchForm.value[name]){
				querys.push(name+'='+this.searchForm.value[name]);
			}
		}
		
		let queryStr = querys.join('&');
		if(!queryStr){
			queryStr = 'searchall=1';
		}
		this.location.replaceState('/members/search',queryStr);
		
	}

	public onSearchClear(): void{
		/*$('select').val(null);
		$('select').trigger('chosen:updated');
		this.searchForm.reset();*/
		for(let it in this.searchForm.controls){
			this.searchForm.controls[it].setValue('');
		}
		$('select').val(null);
		$('select').trigger('chosen:updated');
	}
	
	public datatableSetting: NmDatatableSettings = {
		modelName: 'member',
		fields: [
			{ name: 'YFSID', label: 'YFS ID', sortable: true, searchable: true,search: '' },
			//{ name: 'LegacyYFSID', label: 'Legacy YFS ID', sortable: true, searchable: true, },
			// { name: 'HongKongIdentityCard', label: 'HKID', sortable: true, searchable: true, },
			{ name: 'MemberTypeCode', label: 'Member type', sortable: true, searchable: true, },
			{ name: 'FullName', label: 'Name (English)', sortable: false, searchable: true, },
			{ name: 'ChineseName', label: 'Name (Chinese)', searchable: true },
			{ name: 'SchoolId', label: 'School ID', searchable: true },
			{ name: 'schoolEngName', label: 'School Name (English)' },
			{ name: 'schoolChiName', label: 'School Name (Chinese)' },
			{ name: 'DateOfBirth', label: 'Date of Birth (dd/mm/yyyy)', searchable: true },
			{ name: 'EmailAddress', label: 'Email', searchable: true },
			{ name: 'Telephone1', label: 'Tel (Home)', searchable: true },
			{ name: 'Telephone2', label: 'Tel (Mobile)', searchable: true },
			{ name: 'StatusCode', label: 'Status', searchable: true },
			
		],
		actions: [
			{ name: 'view', icon: 'search-plus', color: 'blue', show: () => true,
				callback: function(id, data) { this.router.navigate([`/members/view/${id}`]); }
			},
			{ name: 'edit', icon: 'pencil', color: 'green', show: () => true,
				callback: function(id, data) { this.router.navigate([`/members/edit/${id}`]); }
			},
			{ name: 'delete', icon: 'trash', color: 'red', show: () => true },
		],
		ajax: {
			url: 'member/datatables'
		},
		ajaxDataMassage: (data: any[]) => {
			
			return data.map(v => {
				// parse json string
				for(let i of ['name', 'mobile_phone']) {
					if(v[i] && typeof v[i] == 'string')
						v[i] = this.helper.parseJsonString(v[i]);
				}
				v.id = v.MemberId;
				v.FullName = v.Surname+' '+v.GivenName;
				v.schoolEngName = v.school?v.school.NameSchool:'';
				v.schoolChiName = v.school?v.school.NameChin:'';
				//console.log('sharedata:',this.data);
	
				
				for(let st of this.data.shared.memberOptions['memberStatusList']){
					if(st.value == v.StatusCode){
						v.StatusCode = st.label;
					}
				}
				for(let st of this.data.shared.memberOptions['memberTypes']){
					if(st.value == v.MemberTypeCode){
						v.MemberTypeCode = st.label;
					}
				}
				if(v.DateOfBirth){
					let birthArr:number[] = v.DateOfBirth.split('-');
					v.DateOfBirth = birthArr[2]+'/'+birthArr[1]+'/'+birthArr[0];
				}
				

				return v;
			})
		}
	};
}



// WEBPACK FOOTER //
// ./src/pages/members/report/report.ts